import { useMutation } from '@apollo/client';
import { Coupon } from '../../shared/types';
import { CITRIN_CREATE_COUPON, CreateCouponRequest, CreateCouponResponse } from '..';

type CreateMutationFunction = (request: Coupon) => Promise<Coupon>;
export const useCreateCouponMutation = (): { mutation: CreateMutationFunction; loading: boolean } => {
    const [mutation, { loading }] = useMutation<CreateCouponResponse, CreateCouponRequest>(CITRIN_CREATE_COUPON);
    const promiseMutation = async (request) => {
        const result = await mutation({
            variables: { request },
        });
        return result.data.CITRIN_MGT_createCoupon;
    };

    return {
        mutation: promiseMutation,
        loading,
    };
};
